import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Cover } from "@/components/library/GridCard";
import { BookMenu, StatusBadge } from "@/components/library/BookMenu";

export const ShelfBook = ({ b, shelves, onDelete, onMove }) => {
  const navigate = useNavigate();
  const [dragging, setDragging] = useState(false);
  return (
    <div className="group flex w-[132px] shrink-0 flex-col sm:w-[150px]" data-testid={`shelf-book-${b.book_id}`}>
      <button
        draggable
        onDragStart={(e) => { e.dataTransfer.setData("text/book-id", b.book_id); e.dataTransfer.effectAllowed = "move"; setDragging(true); }}
        onDragEnd={() => setDragging(false)}
        onClick={() => navigate(`/editor/${b.book_id}`)}
        title={`${b.title} — drag to another shelf`}
        className={`shelf-book relative aspect-[3/4] w-full cursor-grab overflow-hidden rounded-r-lg rounded-l-sm bg-white shadow-[10px_14px_22px_-10px_rgba(100,116,139,.6)] active:cursor-grabbing ${dragging ? "dragging" : ""}`}
        data-testid={`open-book-${b.book_id}`}
      >
        <Cover b={b} rounded="" />
        <span aria-hidden className="pointer-events-none absolute inset-y-0 left-0 w-2.5 bg-gradient-to-r from-black/25 via-white/20 to-transparent" />
      </button>
      <div className="mt-6 flex h-9 items-start justify-between gap-1">
        <div className="min-w-0">
          <h3 className="truncate font-display text-sm font-bold" data-testid={`book-title-${b.book_id}`}>{b.title}</h3>
          <p className="truncate text-[11px] text-[#64748B]"><StatusBadge b={b} /></p>
        </div>
        <BookMenu b={b} shelves={shelves} onDelete={onDelete} onMove={onMove} />
      </div>
    </div>
  );
};
